<script setup lang="ts">
import { computed } from 'vue'
import { HomeButton } from '@/components/home'
import type { LiveOpsLeaderboard } from '@/types/live-ops'
import { liveOpsEventTemplates } from '@/composables/game/live-ops-events'
import { useNow } from '@/composables/game/time'

const props = defineProps<{
  leaderboard: LiveOpsLeaderboard
}>()

const { now } = useNow()

const template = computed(() =>
  liveOpsEventTemplates.value.find(
    t => t.id === props.leaderboard.mainEventTemplateId,
  ) ?? null,
)

const mainColor = computed(() => props.leaderboard.mainColor ?? template.value?.mainColor ?? '#635BFF')
const mainIconUrl = computed(() => props.leaderboard.mainIconUrl ?? template.value?.mainIconUrl ?? '')

const countdown = computed(() =>
  Math.max(0, props.leaderboard.endTimestamp - now.value),
)
</script>

<template>
  <HomeButton
    :label="leaderboard.name"
    :countdown="{ value: countdown, dangerThreshold: 3600 * 3 }"
    :show-sparkle="true"
    :button-class="`p-1`"
    :container-style="{ background: `linear-gradient(180deg, ${mainColor} 0%, ${mainColor}99 55.77%, transparent 100%)` }"
  >
    <img
      class="size-full object-cover z-[3] rounded-[9px]"
      :src="mainIconUrl"
      alt="Live Ops Challenge"
    >
  </HomeButton>
</template>
